import BackgroundImageHelper, {
  Container as BackgroundImageHelperContainer,
} from "@components/BackgroundImageHelper"
import colors from "@constants/colors"
import React from "react"
import styled, { css } from "styled-components"

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  min-width: 200px;
`

const baseStyles = `
  border: transparent;
  border-radius: 50%;
  cursor: pointer;

  &:active, &:focus {
    outline: none;
  }
`

const toggledStyles = `
  border: 2px solid ${colors.black};
`

export const ColorWrapper = styled.div<{
  toggled?: boolean
}>`
  display: flex;
  width: 30px;
  height: 30px;
  margin-right: 10px;
  margin-bottom: 10px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 50%;

  ${({ toggled }) => toggled && toggledStyles}
`

export const ColorSwatch = styled.button<any>`
  ${baseStyles}
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  padding: 0;
  background-color: #${({ hexString }) => hexString || "000000"};
  ${({ hexString }) =>
    `#${hexString && hexString.toUpperCase()}` === colors.white
      ? `border: 1px solid ${colors.borderGray};`
      : ""}
`

export const ImageSwatch = styled.button<{ size: string }>`
  ${({ size }) => css`
    ${baseStyles}
    margin: 0;
    padding: 0;
    background-color: transparent;

    ${BackgroundImageHelperContainer} {
      ${baseStyles}
      width: ${size};
      height: ${size};
      padding: 0;
      overflow: hidden;
      background-color: transparent;
    }
  `}
`

export interface MenuSwatchProps {
  hexString?: string
  label: string
  onClick?: () => void
  swatchImage?: string
  toggled?: boolean
}

interface MenuColorSwatchesProps {
  colors: Array<MenuSwatchProps>
  size?: string
}

const MenuColorSwatches: React.FC<MenuColorSwatchesProps> = ({
  colors,
  size = "20px",
}) => (
  <Container>
    {colors.map((color: MenuSwatchProps, i) => (
      <ColorWrapper
        key={`${i}-${color.label}`}
        toggled={color.toggled || false}
      >
        {color.swatchImage ? (
          <ImageSwatch
            size={size}
            title={color.label}
            {...color}
            onClick={() => {
              if (color.onClick) {
                color.onClick()
                window.scrollTo({ behavior: "smooth", top: 0 })
              }
            }}
          >
            <BackgroundImageHelper src={color.swatchImage} />
          </ImageSwatch>
        ) : (
          <ColorSwatch
            size={size}
            title={color.label}
            {...color}
            onClick={() => {
              if (color.onClick) {
                color.onClick()
                window.scrollTo({ behavior: "smooth", top: 0 })
              }
            }}
          />
        )}
      </ColorWrapper>
    ))}
  </Container>
)

export default MenuColorSwatches
